const UPDATE_MODALS = 'avisos/modals/UPDATE';
const RESET_MODALS = 'avisos/modals/RESET';

export { UPDATE_MODALS, RESET_MODALS };
